import api from './api';

// GET /api/v1/config/public: runtime settings a deployment changes through its task
// definition (sign-up open or closed, upload limits and paths, the demo lock). Answers
// without a login, because the login page needs registration_open.
export const configAPI = {
  getPublic: () => api.get('/api/v1/config/public'),
};
